import { useState } from "react";
import { Box, Button, Paper } from "@mui/material";
import { ClickAwayListener } from "@mui/base/ClickAwayListener";

import {
  AuthPacketButton,
  AuthPacketPaper,
  DownloadButton,
  DownloadButtonBox,
  FaCaretDownIcon,
} from "../style/style";
import { ReferralDetail } from "../../../models/Referral";

type AuthPacketDownloadType = {
  referral: ReferralDetail;
  downloadAuthPacket: (referral: ReferralDetail) => void;
};
const AuthPacketDownload: React.FC<AuthPacketDownloadType> = ({
  referral,
  downloadAuthPacket,
}) => {
  const [openAuthPacketReferralId, setOpenAuthPacketReferralId] = useState<
    number | null
  >(null);

  const handleDownloadButton = (referralId: number) => {
    if (openAuthPacketReferralId === referralId) {
      setOpenAuthPacketReferralId(null);
    } else {
      setOpenAuthPacketReferralId(referralId);
    }
  };

  const handleClickAway = () => {
    setOpenAuthPacketReferralId(null);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box sx={DownloadButtonBox}>
        <Button
          sx={DownloadButton}
          onClick={() => handleDownloadButton(referral.referralId)}
        >
          Downloads
          <FaCaretDownIcon />
        </Button>
        {openAuthPacketReferralId === referral.referralId ? (
          <Paper sx={AuthPacketPaper}>
            <Button
              sx={AuthPacketButton}
              onClick={() => {
                downloadAuthPacket(referral);
                setOpenAuthPacketReferralId(null);
              }}
            >
              Auth Packet
            </Button>
          </Paper>
        ) : null}
      </Box>
    </ClickAwayListener>
  );
};

export default AuthPacketDownload;
